import React, { useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Styles for the modal
const customStyles = {
  content: {
    width: "400px",
    height: "200px",
    margin: "auto",
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "20px",
  },
};

// Set the root element for the modal
Modal.setAppElement("#root");

// Component
const Logoutmodule = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const signout = () => {
    localStorage.removeItem("Name");
    localStorage.removeItem("userCode");
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <>
      <div>
        <div className="loglogout">
          <Link to="" onClick={openModal}>
            <img src="assets/img/logo.png" className="img-fluid color_icons" />
          </Link>
        </div>

        <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
          <div className="module-content">
            <h4>Are you confirm?</h4>
            <p>
              Are you surely to close the <br />
              application
            </p>
            <div style={{ display: "flex" }}>
              <button onClick={closeModal}>DECILNE</button>
              <button onClick={signout}>CONFIRM</button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Logoutmodule;
